import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { PregnancyService } from "../app/pregnancy.service";
import { PatientsService } from "../app/patients.service";
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Measure } from "./measurements/meaure";
import { Subject, Subscription } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { SafeUrl } from "@angular/platform-browser";
import { LoginService } from "./login.service";
import { DatePipe } from "@angular/common";
import { Exam, SRRef } from "./interfaces/exams.service/types";
import { SignatureService } from "./signature.service";
import { ReconnectingSocket, socketOrigin } from "./reconnecting-socket";

@Injectable({
  providedIn: "root",
})
export class ExamsService implements OnDestroy {
  searchReport;
  pregId: number;
  examID: number;
  CreationTime: string;
  isClosed = false;
  LinkSent = false;
  debounce = 500;
  table: string;
  ExamType: string;
  IgnoreFetus = false;
  isGastro = false;
  GASTRO = ["Colonoscopy", "Gastroscopy", "Sigmoidoscopy"];
  private Fetus = 1;
  public fetusChange$: Subject<number> = new Subject<number>();
  public formLoaded$: Subject<void> = new Subject<void>();
  public examLoaded$: Subject<void> = new Subject<void>();
  public mediaArrived$: Subject<string> = new Subject<string>();
  stopRecording: SafeUrl;
  ShowSRs = false;
  // Opaque refs from /api/sr/list: a MediaUUID for reports stored by the new
  // pipeline, or an integer media.AutoIndex (as a string) for legacy rows.
  SRList: string[];
  AWLID: number;
  AWLlmp: Date;
  public Defaults: number;
  public PregCopied: boolean;
  public isForm: boolean;
  public weightAssAll: any;
  weightSub: Subscription;
  formSubs: Subscription[] = [];
  changedTitle = false;
  titleChange: Subject<boolean> = new Subject<boolean>();
  newTitle = "";
  CustomTitlesChanged = new Subject<any>();
  ws: ReconnectingSocket;

  CustomTitles: any = [];
  newTitleItem: UntypedFormGroup;
  disableSaveTitle = false;
  signed = false;
  public OpenerName: string;
  public printAllMeas = new UntypedFormControl(true);
  concentLoaded$ = new Subject();
  concentForm;
  pregnancies;
  _saves = [];
  openNewExam = false;
  dateFields = ["startDateHolter", "endDateHolter"];
  _timer;

  audio = new Audio("../assets/sounds/chime.mp3");

  checkSimilarId: boolean = false;

  // Exam Signature:
  public examSigned$: Subject<any> = new Subject<any>();
  public examObject: Exam;
  public isLoginForEdit: boolean = false;
  public turnToDraft: boolean = false;
  public isSignAndPrint: boolean = false;
  public maccabiResend = false;
  // Clalit report state for the open exam (GET /api/clalit/:examid), or null
  // when the exam is not a Clalit exam.
  public clalit: any = null;
  private clalitRefresh: any = null;

  // Print History:
  awaitPrintHistory: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private router: Router,
    public ps: PregnancyService,
    public patServ: PatientsService,
    private sanitizer: DomSanitizer,
    private login: LoginService,
    private datePipe: DatePipe,
    public signatureService: SignatureService
  ) {
    this.ps.Purpose.valueChanges
      .pipe(debounceTime(this.debounce), distinctUntilChanged())
      .subscribe((data) => {
        this.saveVals("PurposeOfExam", this.ps.Purpose.value, false, "exams");
      });
    this.weightSub = this.fetusChange$.subscribe((res) => {
      this.getAllWeightAssByPre(this.ps.pregID, this.CreationTime, res);
    });
    this.newTitleItem = this.fb.group({
      AutoIndex: new UntypedFormControl(),
      UID: new UntypedFormControl(),
      GID: new UntypedFormControl(),
      Title: new UntypedFormControl(),
      Creation: new UntypedFormControl(),
      isUpdate: new UntypedFormControl(),
    });
    this.CustomTitlesChanged.subscribe((data) => {
      this.CustomTitles = data;
      this.disableSaveTitle = this.CustomTitles.length >= 8;
    });
    
    // Update changedTitle and newTitle when exam is signed
    this.examSigned$.subscribe((examData: Exam) => {
      if (examData) {
        this.examObject = examData;
        this.isClosed = true;
        if (examData.hasOwnProperty('Changed') && examData.hasOwnProperty('ChangedExamTitle')) {
          this.changedTitle = examData['Changed'] ? true : false;
          this.newTitle = examData['ChangedExamTitle'] ? String(examData['ChangedExamTitle']) : "";
        }
      }
    });
  }
  getCustomTitles() {
    this.http.get(`/api/newExams/getCustomTitle`).subscribe((data: any) => {
      this.CustomTitlesChanged.next(data);
    });
  }

  saveNewTitle(GID: number, update: boolean) {
    if (!this.disableSaveTitle) {
      this.newTitleItem.get("isUpdate").patchValue(this.newTitleItem.get("AutoIndex").value !== null);
      this.newTitleItem.get("GID").patchValue(GID);
      this.http
        .post("/api/newExams/saveCustomTitle", { newTitle: this.newTitleItem.value })
        .subscribe((data: any) => {
          if (data.message === "ok") {
            this.getCustomTitles();
            this.newTitleItem.reset({ emitEvent: false });
          }
        });
    }
  }
  resetTitleItem() {
    this.newTitleItem.reset({ eventEmit: false });
  }
  getTitle(index: number) {
    var title = "";
    this.CustomTitles.forEach((c: any) => {
      if (c.AutoIndex === index) {
        this.newTitleItem.patchValue(c);
      }
    });
  }
  deleteTitle(index: number) {
    this.http.delete(`/api/newExams/title/${index}`).subscribe((data: any) => {
      if (data.message === "ok") {
        this.getCustomTitles();
        this.newTitleItem.reset({ emitEvent: false });
      }
    });
  }
  ngOnDestroy() {
    this.weightSub.unsubscribe();
  }

  getExams(patid: string) {
    return this.http.get("/api/exams", {
      params: { PID: patid, uid: this.login.doctor, ID: this.patServ.getPat().ID },
    });
  }

  getDefaults() {
    return this.http.get("/api/defaults");
  }

  setFetus(fetusnum: number) {
    let changed = false;
    if (fetusnum != this.Fetus) changed = true;
    this.Fetus = fetusnum;
    if (changed) this.fetusChange$.next(fetusnum);
  }

  getFetus(): number {
    return this.Fetus;
  }

  /**
   * Loads the exam's structured reports.
   *
   * /api/sr/list returns opaque refs merging both sources: a MediaUUID for reports
   * stored by the new pipeline, an integer media.AutoIndex for legacy rows. The refs are
   * never interpreted here - they go straight back to /api/sr/:ref.
   *
   * Falls back to the old /api/srlist (integer array) when the endpoint is missing, so
   * this build still works against an API that predates it.
   */
  getSRs() {
    this.http.get("/api/sr/list/" + this.examID).subscribe(
      (data: SRRef[]) => {
        this.SRList = (data || []).map((item) => item.ref);
        if (this.SRList.length > 0) this.ShowSRs = true;
      },
      (error) => {
        if (error.status === 404) {
          this.getSRsLegacy();
        } else {
          console.log(error);
        }
      }
    );
  }

  private getSRsLegacy() {
    this.http.get("/api/srlist/" + this.examID).subscribe(
      (data: number[]) => {
        this.SRList = (data || []).map((id) => String(id));
        if (this.SRList.length > 0) this.ShowSRs = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSR(sr: string) {
    return this.http.get("/api/sr/" + encodeURIComponent(sr), { responseType: "text" });
  }

  setForm() {
    switch (this.ExamType) {
      case "Consultation Letter":
        this.isForm = true;
        break;
      default:
        this.isForm = false;
        break;
    }
  }

  startExam(
    name: string,
    patid: number,
    tz: string,
    AWL: number = null,
    lmp: Date = null,
    concent = null
  ) {
    this.ExamType = name;
    this.setForm();
    this.maccabiResend = false;
    this.clearClalit();
    this.http.post("/api/openexam", { PID: patid, ID: tz, ExamType: name, AWLID: AWL }).subscribe(
      (data) => {
        this.examObject = data["exam"];
        this.pregId = data["pregnanciesbasic"]["AutoIndex"];
        this.examID = data["exam"]["AutoIndex"];

        if ((!this.concentForm || !this.concentForm.ExamID) && this.login.hasPremission('Consent'))
          this.setConcentExmID().subscribe((data) => {
            console.log(data);

            this.concentForm["ExamID"] = this.examID;
            this.concentForm["PregID"] = this.pregId;
          });

        this.changedTitle = false;
        this.Defaults = null;
        this.setPurpose("");
        this.ps.Purpose.enable({ emitEvent: false });
        this.CreationTime = data["exam"]["CreationTime"];
        if (
          name != "Follicles" &&
          name != "Gynecology" &&
          !this.login.isCardio &&
          patid > 0 &&
          !this.isForm &&
          !this.login.isGastro
        ) {
          this.ps.setPreg(data["pregnanciesbasic"], false, false);
          this.ps.setExamID(this.examID, this.CreationTime);
        }
        this.isClosed = false;
        this.Fetus = 1;
        this.signed = false;

        this.AWLlmp = lmp;
        this.router.navigate(["/exam"]);
        this.AWLID = AWL;
        this.examLoaded$.next(void 0);
        if (this.login.localServer) this.relayWorklist();
        this.openSocket();
      },
      (error) => {
        // do this part later
        console.log(error);
      }
    );
  }
  setConcentExmID() {
    if (this.concentForm && this.concentForm.ExamType == this.ExamType)
      return this.http.post("/api/letters/saveExamID", {
        examID: this.examID,
        pregID: this.pregId,
        concentID: this.concentForm.AutoIndex,
      });
    else
      return this.http.post("/api/letters/saveExamID", {
        examID: this.examID,
        ExamType: this.ExamType,
        PregID: this.pregId,
      });
  }

  private setPurpose(value) {
    this.ps.Purpose.setValue(value, { emitEvent: false });
  }

  private isNonMedicalStaff(): boolean {
    const medicalRoles = ["doctor", "visitingdoc", "tech"];
    return !medicalRoles.includes(this.login.userType);
  }

  public isDoctor(): boolean {
    return this.login.userType === "doctor";
  }

  goExam(preg, exam, etype: string, viewonly = false) {
    const isExamSigned = this.signatureService.isExamSigned(exam);

    if (!exam) {
      return;
    }
    this.examObject = exam;

    if (preg) {
      this.pregId = preg.AutoIndex;
    } else {
      this.pregId = null;
    }

    this.examID = exam.AutoIndex;

    this.Fetus = 1;
    this.router.navigate(["/exam"]);
    let pid = this.patServ.getPat().PID;
    this.ExamType = etype;
    this.maccabiResend = false;
    this.clearClalit();
    
    // Reset isClosed flag before loading new exam
    this.isClosed = false;

    if (isExamSigned || viewonly) {
      viewonly = true;
    }

    this.setForm();
    this.http
      .get("/api/exam", {
        params: {
          ExamID: this.examID.toString(),
          PregIndex: this.pregId ? this.pregId.toString() : "",
          PID: pid.toString(),
          viewonly: viewonly ? "y" : "n",
        },
      })
      .subscribe(
        (data) => {
          this.CreationTime = data["exam"]["CreationTime"];
          this.ExamType = data["exam"]["ExamType"];
          this.LinkSent = data["exam"]["LinkSent"];
          this.changedTitle = data["exam"]["Changed"];
          this.newTitle = data["exam"]["ChangedExamTitle"];
          this.setPurpose(data["exam"]["PurposeOfExam"]);
          this.isClosed = false;
          if (data["exam"]["printAllMeas"] !== null) {
            this.printAllMeas.patchValue(data["exam"]["printAllMeas"]);
          } else {
            this.printAllMeas.patchValue(true);
          }
          if (data["exam"]["AWLID"]) this.AWLID = data["exam"]["AWLID"];
          this.Defaults = data["exam"]["EDefault"];

          var closedd;
          if (data["exam"]["ClosedDate"]) closedd = new Date(data["exam"]["ClosedDate"]);
          if (data["exam"]["OpenerName"]) this.OpenerName = data["exam"]["OpenerName"];
          else this.OpenerName = null;
          if (data["exam"]["ClosedDate"]) this.signed = true;
          else this.signed = false;

          if (pid > 0 && (this.isNonMedicalStaff() || isExamSigned || viewonly)) {
            this.isClosed = true;
            this.ps.Purpose.disable({ emitEvent: false });
          } else {
             this.isClosed = false;
            this.ps.Purpose.enable({ emitEvent: false });
            //get worklist for local server
            if (this.login.localServer) {
              this.relayWorklist();
            }
          }
          if (preg)
            this.ps.setPreg(
              data["exam"]["PregCopied"] ? data["exam"] : data["pregnancy"],
              false,
              this.isClosed
            );
          this.PregCopied = data["exam"]["PregCopied"];
          if(this.isClosed && this.signed){//check is is maccabi and sent
            this.http.get("/api/cardio/maccabisent/" + this.examID).subscribe((data:any)=>{
              this.maccabiResend = (data['HMO'] == 'Macabi' && data['sentHMO']);
            },err=>{
              console.log(err);
            });
            this.loadClalitStatus();
          }
          this.openSocket();
          this.examLoaded$.next(void 0);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  fillForm(
    form: UntypedFormGroup,
    table: string,
    savePregID = false,
    ignoreFetus = false,
    nosave = [],
    allowSaveWhenClosed = []
  ) {
    this.table = table;
    let params = { table: table, ExamID: this.examID.toString() };
    if (!ignoreFetus) params["fetus"] = this.Fetus.toString();
    this.IgnoreFetus = ignoreFetus;
    var s: Subscription;
    let oldSubs = this.formSubs;
    this.formSubs = [];
    setTimeout(() => {
      while ((s = oldSubs.pop())) s.unsubscribe();
    }, 700); //wait for debounce to expire before unsubscribe
    let f = this.http.get("/api/get", { params: params });
    f.subscribe(
      (data) => {
        if (!data.hasOwnProperty("empty")) {
          for (let key in data) {
            if (form.get(key)) {
              if (data[key] !== null) {
                if (this.dateFields.includes(key)) {
                  data[key] = this.parseDateSqlTOInputDate(data[key]);
                }
                form.get(key).setValue(data[key], { emitEvent: false }); //null ruins formcontrol
              } else {
                if (form.get(key).value != "") form.get(key).setValue("", { emitEvent: false });
              }
            }
          }
        } else form.reset({ emitEvent: false });
        for (let key in form.controls) {
          if (this.isClosed && !allowSaveWhenClosed.includes(key)) {
            form.get(key).disable();
          } else if (!nosave.includes(key)){
              form.get(key).enable({emitEvent:false})
            this.formSubs.push(
              form.controls[key].valueChanges
                .pipe(debounceTime(this.debounce), distinctUntilChanged())
                .subscribe((data) => {
                  this.saveVals(key, form.get(key).value, savePregID, table);
                })
            );
          }
        }

        this.formLoaded$.next(void 0);
      },
      (error) => {
        console.log(error);
      }
    );
    return f;
  }

  fillUngrouped(formarray: UntypedFormControl[], table: string, use_queue = true) {
    this.IgnoreFetus = false;
    this.table = table;
    var s: Subscription;
    let oldSubs = this.formSubs;
    this.formSubs = [];
    setTimeout(() => {
      while ((s = oldSubs.pop())) s.unsubscribe();
    }, 700);
    let f = this.http.get("/api/get", {
      params: { table: table, fetus: this.Fetus.toString(), ExamID: this.examID.toString() },
    });
    f.subscribe(
      (data) => {
        if (!data.hasOwnProperty("empty")) {
          for (let key in data) {
            if (formarray.hasOwnProperty(key)) {
              if (data[key] !== null) formarray[key].setValue(data[key], { emitEvent: false });
              else formarray[key].setValue("", { emitEvent: false }); //empty string ruins formcontrol using dumb hack so things work in anatomy form
            }
          }
        } else {
          //empty - reset everything
          for (let key in formarray) formarray[key].reset("", { emitEvent: false });
        }
        for (let key in formarray) {
          if (this.isClosed) {
            formarray[key].disable();
          } else {
            this.formSubs.push(
              formarray[key].valueChanges
                .pipe(debounceTime(this.debounce), distinctUntilChanged())
                .subscribe((data) => {
                  this.saveVals(key, formarray[key].value, false, this.table, use_queue);
                })
            );
          }
        }
        this.formLoaded$.next(void 0);
      },
      (error) => {
        console.log(error);
      }
    );
    return f;
  }

  setTable(tbl: string) {
    this.table = tbl;
    this.IgnoreFetus = false;
  }

  saveVals(key: string, value: any, preg = false, table = this.table, use_queue = true) {
    //use_queue deprecated
    let p = this.patServ.getPat();
    let values = {
      table: table,
      indexvalue: this.examID,
      PID: p.PID,
      ID: p.ID,
      CreationTime: this.CreationTime,
      field: key,
      value: value,
      fetus: this.IgnoreFetus ? "1" : this.getFetus().toString(),
    };
    if (preg) {
      values["Preg"] = this.ps.pregID;
    }
    this.savePost(values);
  }

  savePost(values, retry = 0) {
    if (this._saves[values.table + "_" + values.field]) {
      //cancel curent save on this field - so that most updated value will be saved even with net problems
      try {
        this._saves[values.table + "_" + values.field][0].unsubscribe();
        clearTimeout(this._saves[values.table + "_" + values.field][1]);
      } catch (e) {
        console.log(e);
      }
    } else this._saves[values.table + "_" + values.field] = [];
    this._saves[values.table + "_" + values.field][1] = setTimeout(() => {
      //cancel the request and retry up to 10 times
      if (retry < 10) {
        this._saves[values.table + "_" + values.field][0].unsubscribe();
        delete this._saves[values.table + "_" + values.field];
        this.savePost(values, retry + 1);
      }
    }, 10000);
    this._saves[values.table + "_" + values.field][0] = this.http.post("/api/save", values).subscribe(
      (data) => {
        console.log(data);
        clearTimeout(this._saves[values.table + "_" + values.field][1]);
        delete this._saves[values.table + "_" + values.field];
      },
      (error) => {
        clearTimeout(this._saves[values.table + "_" + values.field][1]);
        console.log(error);
        clearTimeout(this._saves[values.table + "_" + values.field][1]);
        delete this._saves[values.table + "_" + values.field];
      }
    );
  }

  examGA(ct = this.CreationTime): string {
    try {
      //return this.ps.getGA();
      if (ct == this.CreationTime) return this.ps.getGA();
      let examdays = Measure.WeekToDays(this.ps.getGA());
      let edate = new Date(ct); //the mssql comes out in a different format
      let gaexamdays =
        examdays - (new Date(this.CreationTime).getTime() - edate.getTime()) / (1000 * 24 * 60 * 60);
      return Measure.DaysToWeeks(gaexamdays);
    } catch {
      return "";
    }
  }

  loginMissing() {
    if (!this.examID) this.router.navigate(["/"]);
  }

  record(start: boolean) {
    this.http.get("/api/record/" + this.examID + "/" + (start ? "start" : "stop")).subscribe(
      (data) => {},
      (err) => {
        console.warn(err);
      }
    );
  }

  exitExam(skipPrint: boolean = false) {
    this.patServ.getPat().ID !== "default"
      ? (this.awaitPrintHistory = true)
      : (this.awaitPrintHistory = false);

    if (!this.isClosed && this.patServ.getPat().ID != "default") {
      this.awaitPrintHistory = true;

      const exitPath = `/api/examexit/${this.examID}/${this.AWLID ? this.AWLID : "0"}`;

      this.http.get(exitPath).subscribe();

      let lang = this.login.printLang ? this.login.printLang : "he-IL";

      if (!skipPrint) {
        const printPath = `/api/printpdf/${this.examID}/${this.patServ.getPat().PID}/${lang}/y/n/simple/2/n`;

        this.http.get(printPath).subscribe(
          () => {
            this.awaitPrintHistory = false;
          },
          (err) => {
            this.awaitPrintHistory = false;
            console.log(err);
          }
        );
      }
    }

    this.AWLID = null;
    this.closeSocket();

    if (this.isClosed) {
      this.awaitPrintHistory = false;
    }
  }

  savePrintALl() {
    this.saveVals("printAllMeas", this.printAllMeas.value, false, "exams");
  }

  deleteExam(examid: number, awlid: number) {
    return this.http.delete("/api/exam/" + examid + "/" + (awlid ? awlid : "none"));
  }

  examSignedOrClosed(exam): boolean {
    return !!(
      exam.SignatureCount ||
      exam.TerminationRemarks ||
      exam.ClosedDate ||
      this.signatureService.isExamSigned(exam)
    );
  }

  canDeleteExam(exam): boolean {
    if (!exam) return false;
    const role = this.login.userType;
    if (role !== "doctor" && role !== "tech") return false;
    if (this.examSignedOrClosed(exam)) return false;
    if (role === "doctor") return true;
    return !this.examClosed(new Date(exam.CreationTime));
  }

  deleteDeniedReason(exam): string {
    if (!exam) return "";
    const role = this.login.userType;
    if (role !== "doctor" && role !== "tech")
      return "Only a doctor or a technician can delete an exam.";
    if (this.examSignedOrClosed(exam))
      return "This exam is signed and closed. It cannot be deleted.";
    return "A technician can only delete an exam from the same day. Ask a doctor to delete this one.";
  }

  getLastSummary() {
    return this.http.get(
      "/api/lastdiagnosis/" +
        this.patServ.getPat().PID +
        "/" +
        this.examID +
        "/" +
        (this.ExamType == "Gynecology" ? "y" : "n")
    );
  }

  getLastHistory(gyn = false) {
    return this.http.get(
      "/api/lastmedhistory/" + this.patServ.getPat().PID + "/" + this.examID + "/" + (gyn ? "y" : "n")
    );
  }

  sendLink(phone: string) {
    return this.http.get("/api/sendlink", {
      params: {
        examid: this.examID.toString(),
        pnumber: phone,
        isLetter: this.ExamType === "Consultation Letter" ? true : false,
      },
    });
  }

  sendLinkConcent(phone: string, concentForm = null) {
    console.log(concentForm);

    return this.http.get("/api/letters/sendlinkconcent", {
      params: {
        examID: this.concentForm["ExamID"],
        ConcentID: this.concentForm["AutoIndex"],
        pnumber: phone,
      },
    });
  }

  setDefaults() {
    return this.http.get("/api/applydefaults/" + this.examID);
  }

  relayWorklist() {
    this.http.get("/api/worklist/" + this.examID).subscribe(
      (data) => {
        if (data["worklist"])
          this.http.post("http://localhost:8088/worklist", { worklist: data["worklist"] }).subscribe(
            (data) => {},
            (err) => {
              console.log(err);
            }
          );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  examSearch(fdate, tdate, examtype, uid) {
    var fd;
    var td;
    try {
      fd = fdate._i.year + "-" + (fdate._i.month + 1) + "-" + fdate._i.date;
      td = tdate._i.year + "-" + (tdate._i.month + 1) + "-" + tdate._i.date;
    } catch {
      fd = fdate.toISOString().slice(0, 19).split("T")[0];
      td = tdate.toISOString().slice(0, 19).split("T")[0];
    }
    let echosen = [];
    for (let e in examtype) {
      if (examtype[e]) echosen.push(e);
    }
    return this.http.get("/api/examsearch", {
      params: { from: fd, until: td, exam: JSON.stringify(echosen), uid: uid },
    });
  }

  reportSearch(fdate, tdate, reportName, hmo = null, uid, macabiMissing: false | 'codes' | 'refnum' = false) {
    var fd;
    var td;
    try {
      fd = fdate._i.year + "-" + (fdate._i.month + 1) + "-" + fdate._i.date;
      td = tdate._i.year + "-" + (tdate._i.month + 1) + "-" + tdate._i.date;
    } catch {
      fd = new Date(fdate);
      fd = this.datePipe.transform(fd, "yyyy-MM-dd");
      td = new Date(tdate);
      td = this.datePipe.transform(td, "yyyy-MM-dd");
    }
    return this.http.get("/api/stats/reportsearch", {
      params: { from: fd, until: td, report: reportName, hmo: hmo, uid: uid, macabiMissing: macabiMissing === false ? 'n' : macabiMissing },
    });
  }

  getAllWeightAssByPre(pregID: number, examTime: any, NumFetuses: any) {
    var temp: any = [];
    return this.http.get(
      `/api/newExams/getAllWeightAss/${pregID}/${examTime}/${NumFetuses}/${this.ExamType}`
    );
  }

  getAllWeightData() {
    return this.weightAssAll ? this.weightAssAll.slice() : [];
  }

  examGAByCreation(creationTime): string {
    try {
      //return this.ps.getGA();
      // if(creationTime == this.CreationTime)
      //   return this.ps.getGA();
      let examdays = Measure.WeekToDays(this.ps.getGA());
      let edate = new Date(creationTime); //the mssql comes out in a different format
      let gaexamdays =
        examdays - (new Date(this.CreationTime).getTime() - edate.getTime()) / (1000 * 24 * 60 * 60);
      return Measure.DaysToWeeks(gaexamdays);
    } catch {
      return "";
    }
  }

  getClosing() {
    return this.http.get("/api/cardio/closing/" + this.examID);
  }

  signExam(signer) {
    return this.http.post("/api/cardio/close/" + this.examID, { signer: signer });
  }

  numOgFeatus() {
    // return this.ps.pregForm.value;
    return this.Fetus;
  }
  changeTitle(str: any, changedTitle?: boolean) {
    const isChanged = changedTitle !== undefined ? changedTitle : this.changedTitle;
    this.http
      .post(`/api/newExams/changeTitle`, {
        patient: this.patServ.getPat(),
        examID: this.examID,
        oldTitle: this.ExamType,
        newExamTitle: str,
        Changed: isChanged,
      })
      .subscribe((res: any) => {
        this.newTitle = str;
        this.changedTitle = isChanged;
        this.titleChange.next(isChanged);
      });
  }

  // The CD comes back in this one response. It used to be built on the server and fetched with a
  // second request, which behind the load balancer can reach a server that does not have it.
  getDisk() {
    return this.http.get("/api/disk/" + this.examID + "?download=1", { responseType: "blob", observe: "response" });
  }

  openSocket() {
    // Always start clean: the socket is bound to the exam it was opened for.
    this.closeSocket();
    const examID = this.examID;
    this.ws = new ReconnectingSocket(
      () => socketOrigin() + "/api/examsocket/" + examID,
      (ev) => {
        this.mediaArrived$.next(ev.data);
        if (ev.data == "html") this.getSRs();
        if (this.login.isGastro && ev.data != "full") {
          this.audio.play();
        }
      },
      "exam",
      // Media captured while the socket was down - an image, a clip, a full recording - would
      // otherwise not appear until the NEXT capture. After a reconnect the gallery reloads
      // ('resync' is not 'html', so the measurement screens do not re-apply a structured report)
      // and the SR list is re-read.
      (reconnected) => {
        if (!reconnected) return;
        this.mediaArrived$.next("resync");
        this.getSRs();
      }
    );
  }

  closeSocket() {
    if (this.ws) this.ws.close();
    this.ws = null;
  }

  getAllCalForms(pergID) {
    return this.http.get("/api/newExams/getAllCalForms/" + pergID + "/" + this.patServ.getPat().PID);
  }

  getConcentForms(pid: Number, AWLStatus = null) {
    return this.http.get("/api/letters/getAllConcentForms/" + pid.toString());
  }

  // AR-24: questionnaires answered/pending list for a patient
  getPatientQuestionnaires(pid) {
    return this.http.get("/api/questionnaires/patient/" + pid);
  }

  // AR-24: AI summary of the patient's answered questionnaires for an exam type
  getAiSummary(examType, pid) {
    return this.http.get("/api/questionnaires/ai-summary", {
      params: {
        examType: examType == null ? "" : examType,
        pid: pid == null ? "" : pid,
        examId: this.examID == null ? "" : this.examID,
      },
    });
  }
  saveForm(save = false) {
    if (this.examID) this.concentForm.ExamID = this.examID;
    if (this.pregId) this.concentForm.PregID = this.pregId;
    if (this.concentForm.PregID == "" && this.pregnancies.length > 0 && !this.pregnancies[0].ClosedDate)
      this.concentForm.PregID = this.pregnancies[0].AutoIndex;
    if (save)
      this.http
        .post("/api/letters/saveConcentForm", {
          form: this.concentForm,
          pat: this.patServ.getPat(),
          pregID: this.pregnancies.length > 0 ? this.pregnancies[0].AutoIndex : null,
        })
        .subscribe((data) => {
          console.log(data);
          this.concentForm = data;
        });
  }

  examClosed(examdate = null): boolean {
    let now = new Date();
    var closure = new Date();
    closure.setHours(3);
    closure.setMinutes(0);
    if (now.getHours() < 3) {
      closure.setDate(closure.getDate() - 1);
    }
    if (!examdate) examdate = new Date(this.CreationTime);
    return closure > examdate;
  }

  parseDateSqlTOInputDate(msqlDate) {
    return msqlDate.split("T")[0];
    // "2023-10-02T18:00:00.000Z" parse to yyyy-mm-dd
  }

  hasSimilarPatientId(patientID: string) {
    return this.http.get(`/api/newExams/similar-id/${patientID}`);
  }

  clearClalit() {
    this.clalit = null;
    if (this.clalitRefresh) {
      clearTimeout(this.clalitRefresh);
      this.clalitRefresh = null;
    }
  }

  setClalit(data: any) {
    if (this.clalitRefresh) {
      clearTimeout(this.clalitRefresh);
      this.clalitRefresh = null;
    }
    // enabled is false for clinics that do not report to Clalit at all
    this.clalit = data && data['hmo'] == 'Clalit' && data['enabled'] ? data : null;
    // a scheduled cancellation goes out on the server's next minute tick after
    // it is due - look again then so the screen does not keep offering Undo
    if (this.clalit && this.clalit.pending) {
      const due = this.parseClalitKey(this.clalit.pending.dueKey);
      const wait = due ? Math.max(due.getTime() - Date.now(), 0) + 70000 : 60000;
      const examID = this.examID;
      this.clalitRefresh = setTimeout(() => {
        if (this.examID == examID) this.loadClalitStatus();
      }, wait);
    }
  }

  loadClalitStatus() {
    const examID = this.examID;
    this.http.get(`/api/clalit/${examID}`).subscribe(
      (data) => { if (this.examID == examID) this.setClalit(data); },
      () => { if (this.examID == examID) this.clearClalit(); }
    );
  }

  // 'update', or 'new' to send again after a cancellation
  clalitSend(kind: 'update' | 'new') {
    return this.http.post(`/api/clalit/${this.examID}/send`, { kind });
  }

  // confirmSentKey: the lastSentKey the user was shown when confirming
  clalitCancel(confirmSentKey: string) {
    return this.http.post(`/api/clalit/${this.examID}/cancel`, { confirmSentKey });
  }

  clalitUndoCancel() {
    return this.http.delete(`/api/clalit/${this.examID}/cancel`);
  }

  // server keys are YYYYMMDDHHMMSS, clinic local time
  parseClalitKey(key: string): Date {
    if (!key || !/^\d{14}$/.test(key)) return null;
    return new Date(+key.slice(0, 4), +key.slice(4, 6) - 1, +key.slice(6, 8), +key.slice(8, 10), +key.slice(10, 12), +key.slice(12, 14));
  }

  resendMaccabiReport() {
    let lang = 'he-IL';
    if (this.login.printLang) 
      lang = this.login.printLang;
    return this.http.get(`/api/printpdf/${this.examID}/${this.patServ.getPat().PID}/${lang}/n/n/simple/2/macabi2/n/n`);
  }
}
